import { render, staticRenderFns } from "./MenuWindow.vue?vue&type=template&id=3df53a12&scoped=true"
import script from "./MenuWindow.vue?vue&type=script&lang=js"
export * from "./MenuWindow.vue?vue&type=script&lang=js"
import style0 from "./MenuWindow.vue?vue&type=style&index=0&id=3df53a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df53a12",
  null
  
)

export default component.exports